import classNames from "classnames";
import shiftHeaderRenderer from "components/common/Scheduler/SchedulerRenderers/renderers/shiftHeaderRenderer";
import WorkBlock from "domain/WorkBlock";
import WorkOrder from "domain/WorkOrder";
import flatMap from "lodash/flatMap";
import map from "lodash/map";
import styles from "./eventBuilders.module.scss";

export function buildShiftTimeRanges(shifts) {
  return map(shifts, (shiftInstance) => {
    const shiftHeader = shiftHeaderRenderer({ shiftInstance });
    const uniqueId = `${shiftInstance.name}$${shiftInstance.maxLabor}$${shiftInstance.startingLabor}$${shiftInstance.shiftId}$${shiftInstance.scheduledStart}$${shiftInstance.scheduledEnd}`;

    return {
      endDate: shiftInstance.scheduledEnd,
      id: uniqueId,
      name: shiftHeader,
      startDate: shiftInstance.scheduledStart,
    };
  });
}

export function buildUnavailabilityTimeRanges(unavailabilities) {
  return map(unavailabilities, (unavailability) => {
    const uniqueId = `$${unavailability.line.name}$${unavailability.shift.name}$-${unavailability.startsAt}`;

    return {
      cls: "unavailableBlock spec-unavailability-time-range",
      endDate: unavailability.endsAt,
      id: uniqueId,
      name: "Unavailable",
      resourceId: unavailability.line.id,
      startDate: unavailability.startsAt,
    };
  });
}

export function buildDowntimeBlockEvents(downtimeBlocks) {
  return map(downtimeBlocks, (downtimeBlock) => ({
    block: downtimeBlock,
    cls: styles.downtimeBlock,
    draggable: !downtimeBlock.lockedOnSchedule,
    endDate: new Date(downtimeBlock.endsAt),
    id: downtimeBlock.id,
    resizable: !downtimeBlock.lockedOnSchedule,
    resourceId: downtimeBlock.line.id,
    startDate: new Date(downtimeBlock.startsAt),
  }));
}

export function buildWorkBlockEvents(queriedWorkBlocks) {
  const workOrders = groupWorkBlocksByWorkOrders(queriedWorkBlocks);

  return flatMap(workOrders, (workBlocks) =>
    map(workBlocks, (workBlock) => {
      const blockEvent = buildBlockEvent(workBlock);
      const cardStatus = WorkOrder.cardStatus(workBlock.workOrder);
      const workBlockIdClass = `work-block-${workBlock.id}`;
      const borderStatus = borderCardStatus(workBlock);
      const workBlockBorderClass = styles[`${borderStatus}Border`];

      return {
        ...blockEvent,
        block: workBlock,
        cls: classNames(workBlockIdClass, styles[cardStatus], workBlockBorderClass),
        draggable: !workBlock.lockedOnSchedule,
        endDate: new Date(workBlock.endsAt),
        eventStyle: "null",
        id: workBlock.id,
        resizable: !workBlock.lockedOnSchedule,
        startDate: new Date(workBlock.startsAt),
      };
    }),
  );
}

function borderCardStatus(workBlock) {
  const pastDue = WorkBlock.isPastDue(workBlock);
  const cardStatus = WorkOrder.cardStatus(workBlock.workOrder);

  return pastDue ? "pastDue" : cardStatus;
}

function buildBlockEvent(block) {
  return {
    resourceId: block.line.id,
  };
}

function groupWorkBlocksByWorkOrders(workBlocks) {
  const workOrders = {};

  workBlocks.forEach((workBlock) => {
    const workOrderId = workBlock.workOrder.id;

    if (workOrders[workOrderId]) {
      workOrders[workOrderId].push(workBlock);
    } else {
      workOrders[workOrderId] = [workBlock];
    }
  });

  return workOrders;
}
